import * as Redux from 'redux';
import { ReduxPromiseAction } from '../app/app.types';
import { SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import * as DASHBOARD_ACTION_TYPES from './dashboard.constants';
import { DashboardActionTypes, DashboardEntity } from './dashboard.types';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const getAbsentMembers: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (weeks: number): ReduxPromiseAction<DashboardActionTypes, SimpleResponse<DashboardEntity>> => ({
  type: DASHBOARD_ACTION_TYPES.GET_ABSENT_MEMBERS,
  payload: callApi(
    process.env.REACT_APP_API + '/member/absent/' + weeks,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const getExpiringMembers: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (weeks: number): ReduxPromiseAction<DashboardActionTypes, SimpleResponse<DashboardEntity>> => ({
  type: DASHBOARD_ACTION_TYPES.GET_EXPIRING_MEMBERS,
  payload: callApi(
    process.env.REACT_APP_API + '/member/expiring/' + weeks,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const getCalendarEvents: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (from: number, to: number): ReduxPromiseAction<DashboardActionTypes, SimpleResponse<DashboardEntity>> => ({
  type: DASHBOARD_ACTION_TYPES.GET_CALENDAR_EVENTS,
  payload: callApi(
    process.env.REACT_APP_API + '/calendar/event/list/' + from + '/' + to,
    true,
    {
      method: 'GET',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )   
});

export const createCalendarEvent: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (
  colorValue: string, 
  title: string, 
  startDate: number, 
  endDate: number, 
  note: string,
  memberId?: number,
  staffId?: number
): ReduxPromiseAction<
  DashboardActionTypes, SimpleResponse<DashboardEntity>
> => ({
  type: DASHBOARD_ACTION_TYPES.CREATE_CALENDAR_EVENT,
  payload: callApi(
    process.env.REACT_APP_API + '/calendar/event',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({colorValue, title, startDate, endDate, note, memberId, staffId})
    }
  )    
});

export const updateCalendarEvent: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (
  id: number,
  colorValue: string,
  title: string,
  startDate: number,
  endDate: number,
  note: string,
  memberId?: number,
  staffId?: number
): ReduxPromiseAction<DashboardActionTypes, SimpleResponse<DashboardEntity>> => ({
  type: DASHBOARD_ACTION_TYPES.UPDATE_CALENDAR_EVENT,
  payload: callApi(
    process.env.REACT_APP_API + '/calendar/event',
    true,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({id, colorValue, title, startDate, endDate, note, memberId, staffId})
    }
  ),
  meta: {id: id}
});

export const deleteCalendarEvent: Redux.ActionCreator<
  ReduxPromiseAction<
    DashboardActionTypes, SimpleResponse<DashboardEntity>
  >
> = (id: number): ReduxPromiseAction<DashboardActionTypes, SimpleResponse<DashboardEntity>> => ({
  type: DASHBOARD_ACTION_TYPES.DELETE_CALENDAR_EVENT,
  payload: callApi(
    process.env.REACT_APP_API + '/calendar/event/' + id,
    true,
    {
      method: 'DELETE',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  ),
  meta: {id: id}
});



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.actions.tsx